import UserProfileDetailsInfosItem from './UserProfileDetailsInfosItem';
import { Ban } from 'lucide-react';
import { TAlign } from '.';

type TProps = {
	align?: TAlign;
	user: {
		deviceBanCount?: number;
	}
}

const UserProfileDetailsInfosItemBan = ({ user, align = 'left' }: TProps) => {

	const deviceBanCount = user?.deviceBanCount ?? 0;

	if (deviceBanCount <= 0) {
		return <></>;
	}

	return (
		<UserProfileDetailsInfosItem align={align}>
			<Ban
				size={16}
				className='text-red-500' />
			<p className='flex items-center space-x-1'>
				<span>
					Déjà banni
				</span>
				<span className='text-purple-600'>
					{user.deviceBanCount}
				</span>
				<span>
					fois
				</span>
			</p>
		</UserProfileDetailsInfosItem>
	);

};

export default UserProfileDetailsInfosItemBan;
